import {Component, inject, Input} from '@angular/core';
import {MenuItem} from '@core/types';
// import {NbOptionModule} from '@nebular/theme';
import {AuthStateService} from '@auth/states';
import {ActivatedRoute, Router} from '@angular/router';
import {CompanyStateService} from '@core/states';
import {CONFIG} from '@core/utils';

@Component({
  selector: 'core-sidebar',
  imports: [
    // NbOptionModule
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
  standalone: true,
})
export class Sidebar {

  @Input()
  opened: boolean = false;
  @Input()
  menu: MenuItem[] = [];
  active: string = '';
  private route = inject(ActivatedRoute);

  logoFallback = '/assets/icons/compliance/logo.svg';
  logoError = false;
  private lastCompanyId: string | number | null = null;

  constructor(
    protected authState: AuthStateService,
    protected companyState: CompanyStateService,
    private router: Router
  ) {
    this.route.queryParams.subscribe(params => {
      this.active = params['slug'] || '';
    });
  }

  itemPressed(item: MenuItem) {
    this.active = item.slug;
    item.onPress?.(item);
  }

  get isEmployeeUser(): boolean {
    return this.companyState.isEmployeeMembership(this.companyState.membership());
  }

  goToHome() {
    this.active = 'dashboard';
    this.router.navigate(['/dashboard']);
  }

  logout() {
    this.authState.logout();
  }

  getCompanyId(): string | number | null {
    const companyId = this.companyState.membership()?.company?.id ?? null;
    if (this.lastCompanyId !== companyId) {
      this.logoError = false;
      this.lastCompanyId = companyId;
    }
    return companyId;
  }

  hasCompanyLogo(): boolean {
    return !!this.getCompanyId() && !this.logoError;
  }

  getCompanyLogoUrl(companyId?: string | number | null): string {
    if (!companyId) return this.logoFallback;
    return `${CONFIG.BASE_API_URL}api/public/companies/${companyId}/logo`;
  }

  handleLogoError() {
    this.logoError = true;
  }

  canSelectCompany(): boolean {
    return this.companyState.memberships().length > 1;
  }

  handleCompanyClick() {
    if (!this.canSelectCompany()) return;
    this.router.navigate(['/multi-user']);
  }

}
